(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DettaglioOrdineDeleteController',DettaglioOrdineDeleteController);

    DettaglioOrdineDeleteController.$inject = ['$uibModalInstance', 'entity', 'DettaglioOrdine'];

    function DettaglioOrdineDeleteController($uibModalInstance, entity, DettaglioOrdine) {
        var vm = this;

        vm.dettaglioOrdine = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DettaglioOrdine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
